<template>
  <div class="ui-padding-main">
    <div class="ui-main-container">
      <searchbar :opt="searchbarOpt"></searchbar>
      <el-table
        class="ui-table"
        :header-cell-class-name="tableHeaderCellClassName"
        :cell-class-name="tableContentCellClassName"
        :data="tableData"
        style="width: 100%"
        border
      >
        <el-table-column prop="state" label="Tender NO." width="180">
        </el-table-column>
        <el-table-column prop="state" label="Supplier Name" width="180">
        </el-table-column>
        <el-table-column prop="state" label="Tender Type" width="180">
        </el-table-column>
        <el-table-column prop="content" label="Tender Templat">
        </el-table-column>
        <el-table-column prop="state" label="Total Amount" width="180">
        </el-table-column>
        <el-table-column prop="state" label="状态" width="180">
        </el-table-column>
        <el-table-column label="" width="100">
          <template slot-scope="scope">
            <!--<el-button @click="detail(scope.row)" type="text" size="small">详细</el-button>-->
            <router-link
              :to="'/tenderdetail/' + scope.row.id +'/'"
              class="btn btn-jllred"
              >详细</router-link
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      background
      :page-size="10"
      :hide-on-single-page="true"
      layout="prev, pager, next"
      :total="10"
    >
    </el-pagination>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import searchbar from "../../components/form/SearchBar";
export default {
  components: {
    searchbar
  },
  data() {
    return {
      langcode: "ZH",
      searchbarOpt: {
        placeholder: "",
        text: "",
        filter: {
          show: false
        }
      },
      tableData: [
        {
          state: "全部",
          content: "内容1",
          id: "111"
        },
        {
          state: "投标成功",
          content: "内容2",
          id: "222"
        },
        {
          state: "投标未成功",
          content:
            "内容3内容3内容3内容3内容3内容3内容3内容3内容3内容3内容3内容3内容3内容3内容3内容3内容3333333333333",
          id: "333"
        }
      ]
    };
  },
  computed: {
    ...mapGetters("user", ["hrid", "language"])
  },
  methods: {
    changeLang(lang) {
      this.$i18n.locale = lang;
      this.langcode = lang;
      // this.reload();
    },
    init() {
      this.changeLang(this.language);
    },
    detail(row) {
      console.log(row);
    },
    tableHeaderCellClassName({ row, column, rowIndex, columnIndex }) {
      return "ui-table-header-cell";
    },
    tableContentCellClassName({ row, column, rowIndex, columnIndex }) {
      if (columnIndex !== 0) {
        return "ui-table-content-cell";
      }
    }
  }
};
</script>
<style scoped>
</style>
